/**
 * CommunicationError
 * From: 1.0.0
 *
 * @packageDocumentation
 */

import { Severity } from '../../../constants/Severity';
import { AppError } from '../base';

export class CommunicationError extends AppError {
  static errorName = 'CommunicationFailed';

  constructor(
    severity: keyof typeof Severity,
    res?: Response,
    error?: Error,
    message?: string,
    description?: string
  ) {
    super(error, message || '通信エラーです');
    this.name = res?.statusText || error?.name || 'CommunicationFailed';
    this.status = res?.status;

    if (message) this.message = message;
    if (description) this.description = description;
  }
}

export const toCommunicationError = (
  severity: keyof typeof Severity,
  res: Response,
  baseMessage?: string
) =>
  res
    .json()
    .then((errorInfo) => {
      const ce = new CommunicationError(
        severity,
        res,
        undefined,
        `${baseMessage}`,
        `${errorInfo.message || ''}${
          errorInfo.description && errorInfo.description !== errorInfo.message
            ? ` (${errorInfo.description})`
            : ''
        }`
      );
      ce.code = errorInfo.code;

      return ce;
    })
    .catch(
      (_err) => new CommunicationError('ERROR', res, undefined, baseMessage)
    );
